import { type FirebaseApp, initializeApp } from 'firebase/app';
import { type Auth, getAuth } from 'firebase/auth';
import { type Firestore, getFirestore } from 'firebase/firestore';

import { AppName, metadata } from '@leedpulse-monorepo/firebase-metadata';

type FirebaseModularClient = {
  app: FirebaseApp;
  firestore: Firestore;
  auth: Auth;
};

let clientInstance: FirebaseModularClient | null = null;

function getModularClient(appName: AppName): FirebaseModularClient {
  if (clientInstance) {
    return clientInstance;
  }

  const app = initializeApp(metadata(appName));
  const firestore = getFirestore(app, metadata(appName).databaseId);
  const auth = getAuth(app);

  const client = {
    app,
    firestore,
    auth,
  };
  clientInstance = client;

  return client;
}

export { getModularClient };
